__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-06-01-1780317942-stable-dev/";